import React, { useState, useRef } from 'react';
import { adsAPI } from '../../services/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AdsForm = ({ onAdsCreated }) => {
    const [formData, setFormData] = useState({
        ads_title: '',
        ads_owner_name: '',
        ads_owner_phone: '',
        ads_owner_email: '',
        ads_owner_address: '',
        ads_start_date: '',
        ads_end_date: '',
        ads_amount: '',
        ads_status: 'active',
    });
    const [photo, setPhoto] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const photoRef = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setPhoto(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const data = new FormData();
        Object.keys(formData).forEach(key => {
            data.append(key, formData[key]);
        });
        if (photo) {
            data.append('ads_photo', photo);
        }

        try {
            const response = await adsAPI.create(data);
            // Reset form
            setFormData({
                ads_title: '',
                ads_owner_name: '',
                ads_owner_phone: '',
                ads_owner_email: '',
                ads_owner_address: '',
                ads_start_date: '',
                ads_end_date: '',
                ads_amount: '',
                ads_status: 'active',
            });
            setPhoto(null);
            if (photoRef.current) photoRef.current.value = '';
            if (onAdsCreated) onAdsCreated(response.data.data);
            toast.success('Ad added successfully!');
        } catch (err) {
            console.error(err);
            const errors = err.response?.data?.errors;
            setError(errors || 'Something went wrong');
            if (errors) toast.error(JSON.stringify(errors));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-content">
            <div className="content-wrapper">
                <div className="form-card">
                    <div className="form-card-header">
                        <h5 className="text-white"><i className="fas fa-ad me-2"></i>Add Advertisement</h5>
                        {error && <div className="error">{JSON.stringify(error)}</div>}
                    </div>
                    <div className="form-card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3 mb-3">
                                <div className="col-md-6">
                                    <label>Ad Title</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="ads_title"
                                        value={formData.ads_title}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label>Owner Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="ads_owner_name"
                                        value={formData.ads_owner_name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="row g-3 mb-3">
                                <div className="col-md-4">
                                    <label>Owner Phone</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="ads_owner_phone"
                                        value={formData.ads_owner_phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>Owner Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="ads_owner_email"
                                        value={formData.ads_owner_email}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>Amount</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control"
                                        name="ads_amount"
                                        value={formData.ads_amount}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="row g-3 mb-3">
                                <div className="col-md-6">
                                    <label>Start Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="ads_start_date"
                                        value={formData.ads_start_date}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label>End Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="ads_end_date"
                                        value={formData.ads_end_date}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="row g-3 mb-3">
                                <div className="col-md-6">
                                    <label>Owner Address</label>
                                    <textarea
                                        className="form-control"
                                        name="ads_owner_address"
                                        value={formData.ads_owner_address}
                                        onChange={handleChange}
                                        rows="2"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Status</label>
                                            <select
                                                name="ads_status"
                                                className="form-control"
                                                value={formData.ads_status}
                                                onChange={handleChange}
                                            >
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label>Photo</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                                ref={photoRef}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? 'Wait Please...' : 'Add Ad'}
                            </button>
                        </form>
                    </div>
                    <ToastContainer />
                </div>
            </div>
        </div>
    );
};

export default AdsForm;